import axios from 'axios';

import {AccountPlan} from 'types/account-plan.type';

import {API_URL} from './constants';

const getAccounts = async () => {
    const res = await axios.get(`${API_URL}/accounts`);
    return res.data;
};

const getAccountPlan = async (): Promise<AccountPlan> => {
    const res = await axios.get(`${API_URL}/account-plan`);
    return res.data;
};

export const accountApi = {
    getAccounts,
    getAccountPlan
};